/* eslint-disable max-len */
import { declensionByNumber } from '../declensionByNumber';

export const minutesDeclension: [string, string, string] = [ 'минута', 'минуты', 'минут' ];
export const hoursDeclension: [string, string, string] = [ 'час', 'часа', 'часов' ];
export const daysDeclension: [string, string, string] = [ 'день', 'дня', 'дней' ];
export const weekDeclension: [string, string, string] = [ 'неделя', 'недели', 'недель' ];
export const monthDeclension: [string, string, string] = [ 'месяц', 'месяца', 'месяцев' ];

export const getDeclensionMinutes = (remainderMinutes: number) => `${remainderMinutes}\u00A0${declensionByNumber(remainderMinutes, minutesDeclension)}`;
export const getDeclensionHours = (remainderHours: number) => `${remainderHours}\u00A0${declensionByNumber(remainderHours, hoursDeclension)}`;
export const getDeclensionDays = (remainderDays: number) => `${remainderDays}\u00A0${declensionByNumber(remainderDays, daysDeclension)}`;
export const getDeclensionWeeks = (remainderWeeks: number) => `${remainderWeeks}\u00A0${declensionByNumber(remainderWeeks, weekDeclension)}`;
export const getDeclensionMonths = (remainderMonths: number) => `${remainderMonths}\u00A0${declensionByNumber(remainderMonths, monthDeclension)}`;
